import { useTimetableForVersionQuery, useTimetablesQuery } from '../../../types/planung-graphql-client-defs';

/**
 * Die Antworten enthalten nur `TimetableItem` und `TimetableVersionListItem`. Mutationen an
 * Versionen, Karten und Zeiträumen liefern aber die Knotentypen; damit sie diese Abfragen weiter
 * verwerfen (Versionsliste, Kartenzahl, Zeiträume), hängen deren Typnamen hier an. Jeder Aufrufer
 * der Abfragen muss diesen Context mitgeben.
 */
export const TIMETABLE_QUERY_CONTEXT = {
  additionalTypenames: [
    'TimetableItem',
    'Timetable',
    'TimetableVersion',
    'TimetableCard',
    'TimetableBlock',
    'TimetableBlockItem',
  ],
};

/** Stundenpläne des Schuljahres, zuletzt geänderte zuerst; mit `all` die aller Schuljahre. */
export const useTimetables = (schoolYearUuid: string | undefined, options?: { all?: boolean }) => {
  const [{ data, fetching }, refetch] = useTimetablesQuery({
    variables: { schoolYearUuid: options?.all ? null : (schoolYearUuid ?? '') },
    pause: !options?.all && !schoolYearUuid,
    context: TIMETABLE_QUERY_CONTEXT,
  });
  return { timetables: data?.timetables, fetching, refetch };
};

export const useTimetableForVersion = (versionUuid: string | undefined) => {
  const [{ data, fetching }] = useTimetableForVersionQuery({
    variables: { versionUuid: versionUuid ?? '' },
    pause: !versionUuid,
    context: TIMETABLE_QUERY_CONTEXT,
  });
  return { timetable: data?.timetableForVersion ?? undefined, fetching };
};
